import React, { useState } from 'react'
import AuditLoader from './_load/AuditLoader'
import AuditTable from './table/AuditTable'
import { FilterHandler } from '@btime/react-contexts'
import AuditDetail from './detail/AuditDetail'

const AuditListScreen = ({ id, entity }) => {
  const [openDetail, setOpenDetail] = useState()

  return (
    <>
      <FilterHandler tempStorageNamespace="audit" initialState={{}}>
        <AuditLoader entity={entity} id={id}>
          <AuditTable openDetail={setOpenDetail} />
        </AuditLoader>
      </FilterHandler>

      {openDetail && <AuditDetail data={openDetail} onClose={() => setOpenDetail()} />}
    </>
  )
}

export default AuditListScreen
